import { DEVICES_PATH } from 'rollouts/navigation';

module.exports = {
  path: DEVICES_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/RolloutDevices'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/routes/show/routes/devices/index.js